import moment from 'moment';

import {
  ON_REPORTS_MOUNT,
  ON_REPORTS_MOUNT_ERROR,
  ON_CLICK_DATE_OF_ORDER,
  ON_CLICK_DATE_OF_ATTENDING,
  SELECT_DATE_OF_ORDER_FOCUS_CHANGE,
  SELECT_DATE_OF_ATTENDING_FOCUS_CHANGE,
  SELECT_DATE_ORDER_TIME_RANGE,
  SELECT_DATE_ATTENDING_TIME_RANGE,
  SELECT_DATE_OF_ORDER_CHANGE,
  SELECT_DATE_OF_ATTENDING_CHANGE,
  SELECT_DATE_OF_ORDER_SINGLE_DATE_FOCUS_CHANGE,
  ON_FILTERS_PAYMENT_STATUS_CHANGE,
  SELECT_DATE_OF_ATTENDING_SINGLE_DATE_FOCUS_CHANGE,
  SELECT_DATE_OF_ORDER_SINGLE_DATE_CHANGE,
  SELECT_DATE_OF_ATTENDING_SINGLE_DATE_CHANGE,
  CLOSE_DATE_OF_ORDER_MODAL,
  CLOSE_DATE_OF_ATTENDING_MODAL,
  ON_REPORT_SAVE_DATE_OF_ORDER,
  ON_REPORT_SAVE_DATE_OF_ATTENDING,
  UPDATE_STATE_WITH_FETCHED_REPORT,
  CHECK_ALL_CHECKBOXES,
  ON_VALIDATE_FORM_STARTED
} from '../actions';

const initialState = {
  data: {
    dateOfOrder: {
      modalAppear: false,
      column: 'created_at',
      value: 'all',
      reportTitle: 'Date of Order',
      comparator: '',
      saveDate: false,
      timeRangeSelected: 'all',
      singleDate: moment.utc(),
      singleDateFocused: true,
      customTimeRange: {
        startDate: moment.utc().subtract(1, 'month'),
        endDate: moment.utc()
      },
      timeRanges: [{
        title: 'All dates',
        value: 'all',
        id: 'allDates',
        days: null
      }, {
        title: 'Past 30 days',
        value: 'mtd',
        id: 'pastThirtyDays',
        days: null
      }, {
        title: 'Past 7 days',
        value: 'wtd',
        id: 'pastSevenDays',
        days: null
      }, {
        title: 'Past 24 hours',
        value: 'day',
        id: 'pastDay',
        days: null
      }, {
        title: 'On a specific day...',
        value: 'single',
        id: 'onSpecificDay',
        days: null
      }, {
        title: 'Before a specific day...',
        value: 'before',
        id: 'beforeSpecificDay',
        days: null
      }, {
        title: 'After a specific day...',
        value: 'after',
        id: 'afterSpecificDay',
        days: null
      }, {
        title: 'Custom date range...',
        value: 'custom',
        id: 'customDateRange',
        days: null
      }],
      focusedInput: 'startDate'
    },
    dateOfAttending: {
      modalAppear: false,
      column: 'date_attending',
      value: 'all',
      reportTitle: 'Date Attending',
      comparator: '',
      saveDate: false,
      timeRangeSelected: 'all',
      singleDate: moment.utc(),
      singleDateFocused: true,
      customTimeRange: {
        startDate: moment.utc().subtract(1, 'month'),
        endDate: moment.utc()
      },
      timeRanges: [{
        title: 'All Dates',
        value: 'all',
        id: 'allDates',
        days: null
      }, {
        title: 'Past 30 days',
        value: 'mtd',
        id: 'pastThirtyDays',
        days: null
      }, {
        title: 'Past 7 days',
        value: 'wtd',
        id: 'pastSevenDays',
        days: null
      }, {
        title: 'Past 24 hours',
        value: 'day',
        id: 'pastDay',
        days: null
      }, {
        title: 'On a Specific Day',
        value: 'single',
        id: 'onSpecificDay',
        days: null
      }, {
        title: 'Before a Specific Day',
        value: 'before',
        id: 'beforeSpecificDay',
        days: null
      }, {
        title: 'After a Specific Day',
        value: 'after',
        id: 'afterSpecificDay',
        days: null
      }, {
        title: 'Custom Date Range',
        value: 'custom',
        id: 'customDateRange',
        days: null
      }],
      focusedInput: 'startDate'
    },
    paymentStatus: {
      column: 'ticket_state',
      value: 'all',
      comparator: '=',
      reportTitle: 'Payment Status'
    }
  },
  filters: {
    dateOfOrder: {
      column: 'created_at',
      value: moment().format('YYYY-MM-DD'),
      comparator: '<',
      reportTitle: 'Date of Order'
    },
    dateAttending: {
      column: 'date_attending',
      value: moment().format('YYYY-MM-DD'),
      comparator: '<',
      reportTitle: 'Date Attending'
    },
    paymentStatus: {
      column: 'ticket_state',
      value: 'all',
      comparator: '=',
      reportTitle: 'Payment Status'
    }
  },
  options: {
    dateOfOrder: [{
      filter: 'all',
      value: 'all',
      label: ''
    }, {
      filter: 'pastThirtyDays',
      value: 'mtd',
      label: ''
    }, {
      filter: 'pastSevenDays',
      value: 'wtd',
      label: ''
    }, {
      filter: 'pastDay',
      value: 'day',
      label: ''
    }, {
      filter: 'onSpecificDay',
      value: 'single',
      label: ''
    }, {
      filter: 'beforeSpecificDay',
      value: 'before',
      label: ''
    }, {
      filter: 'afterSpecificDay',
      value: 'after',
      label: ''
    }, {
      filter: 'customDateRange',
      value: 'custom',
      label: ''
    }],
    dateAttending: [{
      filter: 'all',
      value: 'all',
      label: ''
    }, {
      filter: 'pastThirtyDays',
      value: 'mtd',
      label: ''
    }, {
      filter: 'pastSevenDays',
      value: 'wtd',
      label: ''
    }, {
      filter: 'pastDay',
      value: 'day',
      label: ''
    }, {
      filter: 'onSpecificDay',
      value: 'single',
      label: ''
    }, {
      filter: 'beforeSpecificDay',
      value: 'before',
      label: ''
    }, {
      filter: 'afterSpecificDay',
      value: 'after',
      label: ''
    }, {
      filter: 'customDateRange',
      value: 'custom',
      label: ''
    }],
    paymentStatus: [{
      filter: 'all',
      value: 'all',
      label: ''
    }, {
      filter: 'paid',
      value: 'paid',
      label: ''
    }, {
      filter: 'cancelled',
      value: 'cancelled',
      label: ''
    }, {
      filter: 'unauthorized',
      value: 'unauthorized',
      label: ''
    }, {
      filter: 'unpaid',
      value: 'unpaid',
      label: ''
    }, {
      filter: 'expired',
      value: 'expired',
      label: ''
    }, {
      filter: 'partiallyPaid',
      value: 'partially_paid',
      label: ''
    }, {
      filter: 'closed',
      value: 'closed',
      label: ''
    }, {
      filter: 'ended',
      value: 'ended',
      label: ''
    }, {
      filter: 'failed',
      value: 'failed',
      label: ''
    }, {
      filter: 'processing',
      value: 'processing',
      label: ''
    }, {
      filter: 'error',
      value: 'error',
      label: ''
    }, {
      filter: 'transferred',
      value: 'transferred',
      label: ''
    }, {
      filter: 'upgraded',
      value: 'upgraded',
      label: ''
    }, {
      filter: 'declined',
      value: 'declined',
      label: ''
    }, {
      filter: 'unapproved',
      value: 'unapproved',
      label: ''
    }, {
      filter: 'pending',
      value: 'pending',
      label: ''
    }]
  },
  validator: {
    valid: true,
    data: { paymentStatus: true }
  }
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {
    default: return state;

    case ON_REPORTS_MOUNT:
      return Object.assign({}, state, {
        loading: true,
      });

    case ON_REPORTS_MOUNT_ERROR:
      return initialState;

    case SELECT_DATE_ORDER_TIME_RANGE: {
      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfOrder: {
            ...state.data.dateOfOrder,
            timeRangeSelected: action.payload
          }
        }
      });
    }

    case SELECT_DATE_ATTENDING_TIME_RANGE:
      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfAttending: {
            ...state.data.dateOfAttending,
            timeRangeSelected: action.payload
          }
        }
      });

    case ON_CLICK_DATE_OF_ORDER: {
      return {
        ...state,
        data: {
          ...state.data,
          dateOfOrder: {
            ...state.data.dateOfOrder,
            modalAppear: true
          }
        }
      };
    }

    case ON_CLICK_DATE_OF_ATTENDING: {
      return {
        ...state,
        data: {
          ...state.data,
          dateOfAttending: {
            ...state.data.dateOfAttending,
            modalAppear: true
          }
        }
      };
    }

    case SELECT_DATE_OF_ORDER_CHANGE: {
      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfOrder: {
            ...state.data.dateOfOrder,
            customTimeRange: {
              ...state.data.dateOfOrder.customTimeRange,
              startDate: action.payload.startDate,
              endDate: action.payload.endDate
            }
          }
        }
      });
    }

    case SELECT_DATE_OF_ATTENDING_CHANGE: {
      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfAttending: {
            ...state.data.dateOfAttending,
            customTimeRange: {
              ...state.data.dateOfAttending.customTimeRange,
              startDate: action.payload.startDate,
              endDate: action.payload.endDate
            }
          }
        }
      });
    }

    case SELECT_DATE_OF_ORDER_FOCUS_CHANGE: {
      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfOrder: {
            ...state.data.dateOfOrder,
            focusedInput: action.payload
          }
        }
      });
    }

    case SELECT_DATE_OF_ATTENDING_FOCUS_CHANGE: {
      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfAttending: {
            ...state.data.dateOfAttending,
            focusedInput: action.payload
          }
        }
      });
    }

    case SELECT_DATE_OF_ORDER_SINGLE_DATE_CHANGE: {
      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfOrder: {
            ...state.data.dateOfOrder,
            singleDate: action.payload
          }
        }
      });
    }

    case SELECT_DATE_OF_ATTENDING_SINGLE_DATE_CHANGE: {
      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfAttending: {
            ...state.data.dateOfAttending,
            singleDate: action.payload
          }
        }
      });
    }

    case SELECT_DATE_OF_ORDER_SINGLE_DATE_FOCUS_CHANGE: {
      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfOrder: {
            ...state.data.dateOfOrder,
            singleDateFocused: true
          }
        }
      });
    }

    case ON_FILTERS_PAYMENT_STATUS_CHANGE: {
      return {
        ...state,
        data: {
          ...state.data,
          paymentStatus: {
            ...state.data.paymentStatus,
            comparator: '=',
            value: action.payload.value === 'all' ? action.payload.value : action.payload.map(val => val.value)
          }
        },
        validator: {
          ...state.validator,
          data: {
            paymentStatus: Boolean(!action.payload.length)
          }
        }
      };
    }

    case SELECT_DATE_OF_ATTENDING_SINGLE_DATE_FOCUS_CHANGE: {
      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfAttending: {
            ...state.data.dateOfAttending,
            singleDateFocused: true
          }
        }
      });
    }

    case CLOSE_DATE_OF_ORDER_MODAL: {
      let d = helperParseFilter(state.filters.dateOfOrder);

      d = {
        ...state.data.dateOfOrder,
        ...d,
        modalAppear: false
      };

      return {
        ...state,
        data: {
          ...state.data,
          dateOfOrder: d
        }
      };
    }

    case ON_REPORT_SAVE_DATE_OF_ORDER: {
      const res = helperSerializeFilter(state.data.dateOfOrder);

      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfOrder: {
            ...state.data.dateOfOrder,
            value: res.v,
            comparator: res.c,
            modalAppear: false
          }
        },
        filters: {
          ...state.filters,
          dateOfOrder: {
            column: 'created_at',
            value: res.v,
            comparator: res.c
          }
        }
      });
    }

    case ON_REPORT_SAVE_DATE_OF_ATTENDING: {
      const res = helperSerializeFilter(state.data.dateOfAttending);

      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfAttending: {
            ...state.data.dateOfAttending,
            value: res.v,
            comparator: res.c,
            modalAppear: false
          }
        },
        filters: {
          ...state.filters,
          dateAttending: {
            column: 'date_attending',
            value: res.v,
            comparator: res.c
          }
        }
      });
    }

    case CLOSE_DATE_OF_ATTENDING_MODAL: {
      return Object.assign({}, {
        ...state,
        data: {
          ...state.data,
          dateOfAttending: {
            ...state.data.dateOfAttending,
            modalAppear: false
          }
        }
      });
    }

    // this action is called when new columns are fetched for a different type of report
    case CHECK_ALL_CHECKBOXES: {
      const data = { ...state.data };
      const filters = { ...state.filters };

      // Different report types use different columns for the same Humanized column name so we need to
      // make sure that we use the right columns.
      // Use Humanized column name (e.g. Date Attending), compare that to find wanted column from fetched columns
      // update filtering options to have the right column for the right type of report.
      Object.keys(state.data).forEach(filter => {
        const updatedColumn = action.payload.find(column => state.data[filter].reportTitle === column.name);
        data[filter] = {
          ...state.data[filter],
          column: updatedColumn ? updatedColumn.column : state.data[filter].column
        };
      });
      Object.keys(state.filters).forEach(filter => {
        const updatedColumn = action.payload.find(column => state.filters[filter].reportTitle === column.name);
        filters[filter] = {
          ...state.filters[filter],
          column: updatedColumn ? updatedColumn.column : state.filters[filter].column
        };
      });

      return Object.assign({}, {
        ...state,
        data,
        filters
      });
    }

    case UPDATE_STATE_WITH_FETCHED_REPORT: {
      const r = helperParseFilters(action.payload.fetchedReport.filters);

      return {
        ...state,
        data: {
          ...state.data,
          dateOfOrder: {
            ...state.data.dateOfOrder,
            column: r.dateOfOrder.column,
            value: r.dateOfOrder.value,
            comparator: r.dateOfOrder.comparator,
            timeRangeSelected: r.dateOfOrder.timeRangeSelected,
            singleDate: r.dateOfOrder.singleDate ? r.dateOfOrder.singleDate : state.data.dateOfOrder.singleDate,
            customTimeRange: r.dateOfOrder.customTimeRange ? r.dateOfOrder.customTimeRange : state.data.dateOfOrder.customTimeRange
          },
          dateOfAttending: {
            ...state.data.dateOfAttending,
            column: r.dateOfAttending.column,
            value: r.dateOfAttending.value,
            comparator: r.dateOfAttending.comparator,
            timeRangeSelected: r.dateOfAttending.timeRangeSelected,
            singleDate: r.dateOfAttending.singleDate ? r.dateOfAttending.singleDate : state.data.dateOfAttending.singleDate,
            customTimeRange: r.dateOfAttending.customTimeRange ? r.dateOfAttending.customTimeRange : state.data.dateOfAttending.customTimeRange
          },
          paymentStatus: {
            ...state.data.paymentStatus,
            column: r.paymentStatus.column,
            value: r.paymentStatus.value,
            comparator: r.paymentStatus.comparator
          }
        },
        filters: {
          dateOfOrder: {
            column: r.dateOfOrder.column,
            value: r.dateOfOrder.value,
            comparator: r.dateOfOrder.comparator
          },
          dateAttending: {
            column: r.dateOfAttending.column,
            value: r.dateOfAttending.value,
            comparator: r.dateOfAttending.comparator
          },
          paymentStatus: {
            column: r.paymentStatus.column,
            value: r.paymentStatus.value,
            comparator: r.paymentStatus.comparator
          }
        }
      };
    }

    case ON_VALIDATE_FORM_STARTED: {
      const {
        data: { paymentStatus }
      } = state;

      return {
        ...state,
        validator: {
          valid: Boolean(paymentStatus.value.length),
          data: {
            paymentStatus: Boolean(!paymentStatus.value.length)
          }
        }
      };
    }
  }
};

function helperSerializeFilter(f) {
  // Add custom data to the filters.dateOfOrder object
  // Enables passing all filters through a URL string query
  const res = {};

  switch (f.timeRangeSelected) {
    default:
    case 'all': {
      res.v = 'all';
      res.c = '<';
      break;
    }
    case 'mtd': {
      res.v = '30';
      res.c = 'days_ago';
      break;
    }
    case 'wtd': {
      res.v = '7';
      res.c = 'days_ago';
      break;
    }
    case 'day': {
      res.v = '1';
      res.c = 'days_ago';
      break;
    }
    case 'single': {
      res.v = f.singleDate.utc().format();
      res.c = '=';
      break;
    }
    case 'before': {
      res.v = f.singleDate.utc().format();
      res.c = '<';
      break;
    }
    case 'after': {
      res.v = f.singleDate.utc().format();
      res.c = '>';
      break;
    }
    case 'custom': {
      res.v = f.customTimeRange.startDate.utc().format() + ',' + f.customTimeRange.endDate.utc().format();
      res.c = '...';
      break;
    }
  }
  return res;
}


function helperParseFilters(filters) {
  const result = {};

  for (let f = 0; f < filters.length; f++) {
    switch (filters[f].column) {
      default: break;
      // for the reasons described in /reports/actions/sagas.js,
      // when we get back two filters for the same column, we need to make sure to put them back together
      // to use '...' comparator for enterprise to parse things correctly.
      // for Date of Order
      case 'created_at': {
        const filter = helperParseFilter(filters[f]);
        if (!result.dateOfOrder) {
          result.dateOfOrder = filter;
        }
        else {
          result.dateOfOrder = {
            ...result.dateOfOrder,
            comparator: '...',
            value: `${result.dateOfOrder.value.split(',')[0]},${filter.value}`,
            timeRangeSelected: 'custom',
            customTimeRange: {
              startDate: moment(result.dateOfOrder.value.split(',')[0]),
              endDate: moment(filter.value)
            }
          };
        }
        break;
      }
      // all these cases are for Date Attending
      case 'event_start_time':
      case 'start_stamp':
      case 'date_attending': {
        const filter = helperParseFilter(filters[f]);
        if (!result.dateOfAttending) {
          result.dateOfAttending = filter;
        }
        else {
          result.dateOfAttending = {
            ...result.dateOfAttending,
            comparator: '...',
            value: `${result.dateOfAttending.value.split(',')[0]},${filter.value}`,
            timeRangeSelected: 'custom',
            customTimeRange: {
              startDate: moment(result.dateOfAttending.value.split(',')[0]),
              endDate: moment(filter.value)
            }
          };
        }
        break;
      }
      case 'state':
      case 'ticket_state': {
        result.paymentStatus = helperParseFilter(filters[f]);
        break;
      }
    }
  }
  return result;
}

function helperParseFilter(f) {
  const res = {};
  res.comparator = f.comparator;
  res.column = f.column;
  res.value = f.value;

  // Returning timeRangeSelected
  switch (f.comparator) {
    case '...': {
      res.timeRangeSelected = 'custom';

      const strings = f.value.split(',');
      res.customTimeRange = {
        startDate: moment(strings[0]),
        endDate: moment(strings[1])
      };
      break;
    }
    case 'days_ago': {
      if (f.value === '1') {
        res.timeRangeSelected = 'day';
        res.singleDate = moment.utc(); // reset to now
        break;
      }
      else if (f.value === '7') {
        res.timeRangeSelected = 'wtd';
        res.singleDate = moment.utc(); // reset to now
        break;
      }
      else {
        res.timeRangeSelected = 'mtd';
        res.singleDate = moment.utc(); // reset to now
        break;
      }
    }
    case '>': {
      res.timeRangeSelected = 'after';
      res.singleDate = moment(f.value);
      break;
    }
    case '<': {
      if (f.value === 'all') {
        res.timeRangeSelected = 'all';
        res.singleDate = moment.utc(); // reset to now
        break;
      }
      else {
        res.timeRangeSelected = 'before';
        res.singleDate = moment(f.value);
        break;
      }
    }
    case '=': {
      res.timeRangeSelected = 'single';
      res.singleDate = moment(f.value);
      break;
    }
  }

  return res;
}



// WEBPACK FOOTER //
// ./src/modules/reports/reducers/custom-filters.js